import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { formatTimestamp } from './time-tools'
import css from './chip.css'

const labelTimestamp = (scheduledFor, isCancelled) => {
  if (isCancelled) {
    return 'CANCELLED'
  }

  return scheduledFor ?
    formatTimestamp('chip', scheduledFor) :
    'SCHEDULED'
}

const Chip = ({ blast, isSelected, handleClick }) => {
  const info = labelTimestamp(blast.scheduledFor, blast.isCancelled)
  const spanClass = cx(css.info, { [css.selected]: isSelected })

  return (
    <span
      className={spanClass}
      onClick={() => handleClick(blast.id)}
    >
      {info}
    </span>
  )
}

Chip.propTypes = {
  blast: PropTypes.shape({
    id: PropTypes.number.isRequired,
    scheduledFor: PropTypes.string.isRequired,
    isCancelled: PropTypes.bool.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
}

Chip.defaultProps = {
  isSelected: false,
}

export default Chip



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/Chip.js